// extracted by mini-css-extract-plugin
export default {"container":"SalesRepAiInsights_container__VCRFO","list":"SalesRepAiInsights_list__XzU+f"};